<template>
  <v-dialog v-model="dialog" persistent width="600">
    <common-card>
      <v-card-text class="pa-4 black--text" style="text-align: center;">
        <v-row>
          <v-col
            cols="12"
            style="text-align: end; cursor: pointer;"
            @click="$emit('closeModal')"
          >
            <v-icon left color="#858C94">
              mdi-close
            </v-icon>
          </v-col>
        </v-row>
        <div class="pt-5 pb-5 top-text" style="width: 100%; height: 100%; justify-content: center;">
            La emision requiere completar estado civil del cliente
        </div>
        <div class="pt-5 pb-5">
         <v-form ref="formEstatusCivil" :lazy-validation="true">
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  label="Estado civil"
                  outlined
                  color="#00a7e4"
                  v-model="formData.statusCivil"
                  :items="['Soltero(a)', 'Casado(a)', 'Unión Libre']"
                  :rules="requiredRule"
                ></v-autocomplete>
              </v-col>
            </v-row>
         </v-form>
        </div>
        <div>
          <v-row>
            <v-col cols="12">
              <v-btn
                :loading="loading"
                outlined
                color="#00a7e4"
                block
                x-large
                @click="update"
                > <h4>
                  Guardar
                </h4> </v-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </common-card>
  </v-dialog>
</template>

<script>
import CommonCard from "../../commonComponents/CommonCard.vue";
import { updatePolizaManual } from "@/services/emision/emision.service";
export default {
  components: {
    CommonCard,
  },
  props: {
    dialog: Boolean,
    emision_id:{
      type:Number,
      default:null
    },
  },

  data() {
    return {
      formData:{
        statusCivil:null
      },
      requiredRule: [(v) => !!v || "El campo es requerido"],
      loading:false
    };
  },
  methods: {
    userChoice(val) {
      this.$emit("userChoice", val);
    },
    async update(){
        if(this.$refs.formEstatusCivil.validate()){
          this.updatePoliza()
        }
    },
    async updatePoliza(){
      this.loading = true
      let request = {
        ...this.formData,
        id:this.emision_id
      }
      console.log(request)
      try{
        await updatePolizaManual(request)
        this.$toast.success('Emision actualizada con exito')
        this.$emit('success-emision')
        this.loading = false
      }catch{
        this.$toast.error('Fallo la actualizacion')
        this.$emit('closeModal')
        this.loading = false
      }
    }
  },
};
</script>

<style>
.v-toolbar--dense .v-toolbar__content,
.v-toolbar--dense .v-toolbar__extension {
  padding-top: 0;
  padding-bottom: 0;
  justify-content: center;
}

.top-text{
width: 369px;
height: 22px;
font-family: 'Montserrat';
font-style: normal;
font-weight: 700;
font-size: 20px;
line-height: 110%;
display: flex;
align-items: center;
text-align: center;
color: #4D5358;
flex: none;
order: 0;
flex-grow: 1;
}


.confirmation-text{
  /* Por favor, asegúrate de revisar cuidadosamente los cambios antes de continuar */

width: 369px;
height: 30px;

/* Subtitle/S */
font-family: 'Montserrat';
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 110%;
/* or 15px */
text-align: center;

color: #555555;


/* Inside auto layout */
flex: none;
order: 2;
align-self: stretch;
flex-grow: 0;

}

</style>
